import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_kh: z.string().optional(),
  tk: z.string().optional(),
  ma_unit: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const formSchema = z.object({
  ngay_ct: z.string().optional(),
  ngay_lct: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_nt: z.string().optional(),
  ty_gia: z.number().optional(),
  status: z.string().optional(),
  transfer_yn: z.boolean().optional(),
  t_ps_co_nt: z.number().optional(),
  t_ps_no_nt: z.number().optional(),
  t_ps_co: z.number().optional(),
  t_ps_no: z.number().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ngay_ct: format(new Date(), 'yyyy-MM-dd'),
  ngay_lct: format(new Date(), 'yyyy-MM-dd'),
  dien_giai: '',
  ma_nt: '',
  ty_gia: 1,
  transfer_yn: false,
  status: '5',
  t_ps_co_nt: 0,
  t_ps_no_nt: 0,
  t_ps_co: 0,
  t_ps_no: 0
};
